import { Injectable } from '@angular/core';
import { IQPointSettingsService } from '@qpoint/utils';

@Injectable()
export class Settings implements IQPointSettingsService {
    public serverPath: string = null;
}
